// ACTIVITY FEED
/*****************************************************************/
export const proHome = (): string => '/pro';
export const postAttachmentUrl = (id: string | number): string =>
  `/pro/post_attachments/${id}/download`;

// Contributor Center
/*****************************************************************/
export const contributorDashboardFundProfileUrl = (): string =>
  '/pro/contributor_items/fund_profile';
export const contributorDashboardIdeasUrl = (id?: string | number): string =>
  `/pro/contributor_items/ideas${id ? `/${id}` : ''}`;
export const contributorDashboardInsightsUrl = (): string => '/pro/contributor_items/posts';
export const contributorDashboardUrl = (): string => '/pro/contributor_items';

// RESEARCH
/*****************************************************************/
// => NEW
export const NEW_RESEARCH_ROUTES = {
  BASE: '/pro/research/new',
  IDEA: '/idea',
  MACRO_THEMATIC: '/macro_thematic'
};
export const newResearchUrl = (postingRequest?: string): string =>
  `${NEW_RESEARCH_ROUTES.BASE}${postingRequest ? '?posting_request=true' : ''}`;
export const newIdeaUrl = (postingRequest?: boolean): string =>
  `${NEW_RESEARCH_ROUTES.BASE + NEW_RESEARCH_ROUTES.IDEA}${
    postingRequest ? '?posting_request=true' : ''
  }`;
export const newMacroThematicUrl = (id?: string | number): string =>
  `${NEW_RESEARCH_ROUTES.BASE + NEW_RESEARCH_ROUTES.MACRO_THEMATIC}${id ? `/${id}` : ''}`;

// => CONTESTS
export const contestsUrl = (): string => '/pro/contests/';
export const contestUrl = (contestId: string | number): string => `/pro/contests/${contestId}`;
export const eventRegistrationUrl = (): string => '/pro/top-stocks-25-investor-summit';
// => IDEAS
export const ideaCommentsUrl = (ideaId: string | number): string =>
  `/pro/research/ideas/${ideaId}#idea_comments`;
export const ideaCreateUpdateUrl = (id: string | number): string =>
  `/pro/research/ideas/${id}#idea_updates`;
export const ideaEditUrl = (id?: string | number): string =>
  `${NEW_RESEARCH_ROUTES.BASE + NEW_RESEARCH_ROUTES.IDEA}${id ? `/${id}` : ''}`;
export const ideaSearchUrl = (searchQuery: string): string =>
  `/pro/research/ideas?page=1&${searchQuery}`;
export const ideaUpdatesUrl = (ideaId: string | number): string =>
  `/pro/research/ideas/${ideaId}#idea_updates`;
export const ideasUrl = (): string => '/pro/research/ideas';
export const ideaUrl = (id: string | number, recommendationId?: string | number): string =>
  `/pro/research/ideas/${id}${recommendationId ? `?recommendation_id=${recommendationId}` : ''}`;
export const ideaUpdateUrl = (ideaId: string | number, updateId: string | number): string =>
  `/pro/research/ideas/${ideaId}#ideaupdate-${updateId}`;
export const requestToPayUrl = (): string => '/pro/research/ideas/request_access';
export const weeklyTopIdeasUrl = (): string => '/pro/research/ideas?page=1&weekly_top_ideas=true';
export const publicIdeasUrl = (): string => '/public/ideas';
// => IDEA ATTACHMENTS
export const ideaAttachmentUrl = (id: string | number): string =>
  `/pro/research/idea_attachments/${id}/download`;
// => FUND LETTERS
export const fundLetterIndexUrl = (): string => '/public/fund_letters';

// White Papers
/*****************************************************************/
export const whitePaperEditUrl = (id: string | number): string =>
  NEW_RESEARCH_ROUTES.BASE + NEW_RESEARCH_ROUTES.MACRO_THEMATIC + '/' + id;
export const whitePaperShowUrl = (id: string | number): string =>
  `/pro/research/white_papers/${id}`;
export const whitePaperAttachmentUrl = (id: string | number): string =>
  `/pro/research/white_paper_attachments/${id}`;
export const whitePaperIndexUrl = (): string => '/pro/research/white_papers';
export const whitePaperSearchUrl = (searchQuery: string): string =>
  `/pro/research/white_papers?page=1&${searchQuery}`;
export const whitePaperCommentsUrl = (id: string | number): string =>
  `/pro/research/white_papers/${id}#white-paper-comments`;

// Comments
/*****************************************************************/
export const commentAttachmentsUrl = (id: string | number): string =>
  `/pro/comment_attachments/${id}/download`;

// MEMBERS/RANKINGS
/*****************************************************************/
export const usersUrl = (): string => '/pro/members/profiles';
export const userUrl = (id?: string | number): string => `/pro/members/profiles/${id}?user=true`;
export const profileUrl = (id: string | number): string => `/pro/members/profiles/${id}`;
export const postsUrl = (): string => '/pro/members/posts';
export const postsSearchUrl = (searchQuery: string): string => `/pro/members/posts/?${searchQuery}`;
export const postUrl = (id: string | number): string => `/pro/members/posts/${id}`;
export const profileSearchUrl = (params: { [key: string]: string }): string =>
  `/pro/members/profiles?page=1&${new URLSearchParams(params).toString()}`;
export const rankingsUrl = (): string => '/pro/members/rankings';
export const publicRankingsUrl = (category?: string): string =>
  `/public/rankings${category ? `/${category}` : ''}`;
export const rankingsLTMUrl = (): string => '/pro/members/rankings/last_twelve_months';
export const rankingUrl = (category?: string): string =>
  `/pro/members/rankings/${category ? category : ''}`;
export const profileAttachmentUrl = (id: string | number): string =>
  `/pro/profile_attachments/${id}/download`;

// CAP INTRO
/*****************************************************************/
export const employerProfilesUrl = (): string => '/pro/cap-intro/funds';
export const employerProfileUrl = (id: string | number): string =>
  `/pro/cap-intro/funds/${id}/redirect_employer_id`;
export const employerProfileVanityUrl = (vanityLink: string): string =>
  `/pro/cap-intro/funds/${vanityLink}`;
export const allocatorProfilesUrl = (): string => '/pro/cap-intro/allocators';
export const allocatorProfileUrl = (vanityOrId: string | number): string =>
  `/pro/cap-intro/allocators/${vanityOrId}`;
export const employerProfileIndexUrl = (): string => '/pro/cap-intro/funds/';
export const employerProfileDocumentUrl = (id: string | number): string =>
  `/pro/cap-intro/employer_profile_documents/${id}/download`;
export const dueDiligenceDocumentUrl = (id: string | number): string =>
  `/pro/cap-intro/due_diligence_documents/${id}/download`;
export const defaultExecutivePhotoUrl = (): string => '/images/shared/default_icon_200.png';
export const defaultPressImageUrl = (): string => '/images/pro/icons/press-missing.png';
export const capIntroSplashUrl = (): string => '/pro/cap-intro/access';
export const requestAccessToCapIntroUrl = (): string => '/pro/cap-intro/funds/request_access';
export const accreditedInvestorProfilesIndexUrl = (): string =>
  '/pro/cap-intro/accredited_investors';
export const recommendedEmployerProfilesUrl = (): string => '/pro/cap-intro/funds?recommended=true';

// CAREERS
/*****************************************************************/
export const compensationsUrl = (): string => '/pro/compensation';
export const compensationNewUrl = (): string => '/pro/compensation/new';
export const compensationUrl = (id: string | number): string => `/pro/compensation/${id}/info`;
export const compensationEditUrl = (id: string | number): string => `/pro/compensation/${id}/edit`;
export const jobVaultPostingsUrl = (): string => '/pro/job_postings';
export const jobVaultPostingUrl = (id: string | number): string => `/pro/job_postings/${id}`;
export const jobVaultIndexUrl = (): string => '/pro/job_postings';
export const jobVaultNewUrl = (): string => '/pro/job_postings/new';
export const jobVaultAppsReceived = (appLink: string): string => `/pro/${appLink}`;
export const jobPostAppUrl = (postId: string | number, appId: string | number): string =>
  `/pro/job_postings/${postId}/job_applications/${appId}`;
export const jobPostAppsUrl = (postId: string | number): string =>
  `/pro/job_postings/${postId}/job_applications`;
export const newJobApplication = (jobPostId: string | number): string =>
  `/pro/job_postings/${jobPostId}/job_applications/new`;
export const jobApplicationShowUrl = (
  jobPostId: string | number,
  jobApplicationId: string | number
): string => `/pro/job_postings/${jobPostId}/job_applications/${jobApplicationId}`;

// MESSAGES
/*****************************************************************/
export const messagesUrl = (): string => '/pro/messages';
export const messageUrl = (id: string | number): string => `/pro/messages/${id}`;
export const messageAttachmentUrl = (id: string | number): string =>
  `/pro/message_attachments/${id}/download`;
export const newMessageUrl = (userId: string | number): string =>
  `/pro/messages/new?to_id=${userId}`;

// USER
/*****************************************************************/
export const employerUrl = (id: string | number): string => `/pro/employers/${id}`;
export const defaultUserImageUrl = (): string => '/images/shared/avatar-missing-115.png';
export const userIdeaUrl = (id: string | number): string => `/pro/user/${id}/public/research/ideas`;
export const userFollowingUrl = (id: string | number): string => `/pro/user/${id}/public/following`;
export const userFollowersUrl = (id: string | number): string => `/pro/user/${id}/public/followers`;
export const userRatingsUrl = (): string => '/pro/user/account/ratings';
export const userBadgesUrl = (): string => '/pro/user/account/badges';
export const manageSavedSearchesUrl = (): string => '/pro/user/account/search_alerts';
export const userWatchlistUrl = (): string => '/pro/user/account/watchlist';
export const userReadingListUrl = (): string => '/pro/user/account/reading_list';
export const userCompensationsUrl = (): string => '/pro/user/account/compensations';
export const jobPostingUrl = (): string => '/pro/user/account/job_postings';
export const userJobApplicationsUrl = (): string => '/pro/user/account/job_applications';
export const userReferralsUrl = (): string => '/pro/user/account/referrals';
export const buysideSignUpUrl = (referrerId?: string | number): string =>
  `/apply${referrerId ? `?referrer_id=${referrerId}` : ''}`;
export const userAccountUrl = (): string => '/pro/user/account';
export const userAccountIdeasUrl = (): string => '/pro/user/account/ideas';
export const userAccountFollowingUrl = (): string => '/pro/user/account/following';
export const userAccountFollowersUrl = (): string => '/pro/user/account/followers';
export const userAccountViewerIntroRequestsUrl = (): string =>
  '/pro/user/account/viewer_intro_requests';
export const userAccreditedInvestorQuestionnaireUrl = (): string =>
  '/pro/accredited_investor_profiles/new';
export const emailSettingUrl = (): string => '/pro/user/account/notifications';
export const notificationsSettingUrl = (): string => '/pro/user/account/site_notifications';
export const billingInformationUrl = (): string => '/pro/user/account/billing_information';
export const userPaladinReviewsUrl = (id: string | number): string =>
  `/pro/user/${id}/research/paladin_reviews`;

// COMPANY/ENTITIES
/*****************************************************************/
export const entityUrl = (id: string | number): string => `/pro/entities/${id}`;

// ADMIN
/*****************************************************************/
export const adminSelectAsWeeklyTopIdea = (id: string | number): string =>
  `/admin/pro/weekly_quick_ideas/new?idea_id=${id}`;
export const adminSelectAsQTI = (id: string | number): string =>
  `/admin/retail/retail_qtis/new?idea_id=${id}`;
export const adminEditIdea = (id: string | number): string => `/admin/pro/ideas/${id}/edit`;
export const adminIdea = (id: string | number): string => `/admin/pro/ideas/${id}`;
export const adminRedraftIdea = (id: string | number): string => `/admin/pro/ideas/${id}/redraft`;
export const adminReopenIdea = (id: string | number): string => `/admin/pro/ideas/${id}/reopen`;
export const adminEditIdeaUpdate = (
  ideaId: string | number,
  ideaUpdateId: string | number
): string => `/admin/pro/ideas/${ideaId}/updates/${ideaUpdateId}/edit`;
export const adminPaladinPage = (id: string | number): string => `/admin/pro/paladins/${id}`;
export const adminUserPage = (id: string | number): string => `/admin/pro/users/${id}`;
export const adminBecomeUser = (id: string | number): string =>
  `/admin/pro/users/${id}/become_user`;
export const adminEntityEdit = (id: string | number): string => `/admin/pro/entities/${id}/edit`;
export const compensationAdminEditUrl = (id: string | number): string =>
  `/admin/pro/compensations/${id}/edit`;
export const adminEntityMergeUrl = (id?: string | number): string =>
  `/admin/pro/entities/merge${id ? `?merging_entity_id=${id}` : ''}`;

// HOME PUBLIC LINKS
/*****************************************************************/
export const termsOfUseUrl = (): string => '/terms_of_use';
export const privacyPolicyUrl = (): string => '/privacy_policy';
export const generalDisclaimerUrl = (): string => '/general_disclaimer';

// OPEN SUMZERO LINKS
/*****************************************************************/
export const openCompanyPageUrl = (id: string | number): string => `/public/entities/${id}`;

// MISC
/*****************************************************************/
// Posts reference fs_perm_sec_id, so that is why we use that (we don't have SZ asset ids on EdmService)
export const assetUrl = (fs_perm_sec_id: string | number): string =>
  `/pro/assets/${fs_perm_sec_id}`;
export const onboardingUrl = (): string => '/pro/getting_started';
export const adminUrl = (): string => '/admin';
export const inviteMembersUrl = (): string => '/pro/invitations/new';
export const logoutUrl = (): string => '/logout';
export const notificationsUrl = (): string => '/pro/notifications';
export const qualityGuidelinesUrl = (): string => '/quality_guidelines';
export const loginUrl = (): string => '/login';
export const basicHomeUrl = (): string => '/basic/home';
export const specificBlogPost = (id: string | number): string => `/headlines/${id}`;
export const accessIdeasUrl = (): string => '/pro/subscribe';

// VIEWER INTRO REQUESTS
/*****************************************************************/
export const newViewerIntroRequestMessageUrl = (
  introId: string | number,
  userId: string | number
): string => `/pro/viewer_intro_requests/${introId}/message?to_id=${userId}`;

// MEDIA
/*****************************************************************/
export const videoIndexUrl = (tag?: string): string => `/public/videos${tag ? '?text=' + tag : ''}`;
export const videoShowUrl = (idOrVanityLink: string): string => `/public/videos/${idOrVanityLink}`;
export const podcastEpisodeIndexUrl = (tag?: string): string =>
  `/public/podcast_episodes${tag ? '?text=' + tag : ''}`;
export const podcastEpisodeShowUrl = (idOrVanityLink: string): string =>
  `/public/podcast_episodes/${idOrVanityLink}`;
export const mediaIndexUrlFor = (type: string): ((tag?: string) => string) => {
  if (/video/i.test(type)) return videoIndexUrl;
  if (/podcast/i.test(type)) return podcastEpisodeIndexUrl;

  return proHome;
};
export const mediaShowUrlFor = (type: string): ((idOrVanityLink: string) => string) => {
  if (/video/i.test(type)) return videoShowUrl;
  if (/podcast/i.test(type)) return podcastEpisodeShowUrl;

  return proHome;
};

// Chats
export const quickPositionsPageUrl = (chatId?: string | number): string =>
  `/pro/quick_positions${chatId ? `/${chatId}` : ''}`;
export const sectorChatsUrl = (chatId?: string): string =>
  `/pro/sector-chats${chatId ? `/${chatId}` : ''}`;

// SEC Filings
export const insiderTradesPageUrl = (): string => '/pro/sec_filings/insider_trades';

// API
/*****************************************************************/
export const oauth2Redirect = (): string => '/api/oauth2/redirect';
export const lnkdOAuth2Redirect = (): string => '/api/oauth2/lnkd_redirect';
